var map = {
	"./accounting-advisory.jpg": 426,
	"./accounting-advisory.webp": 674,
	"./accounting.jpg": 5516,
	"./accounting.webp": 7406,
	"./ai-governance.jpg": 5368,
	"./ai-governance.webp": 3132,
	"./ai-gra.jpg": 8182,
	"./ai-gra.webp": 9396,
	"./business-development.jpg": 85,
	"./business-development.webp": 1469,
	"./business-law.jpg": 6534,
	"./business-law.webp": 9616,
	"./cac.jpg": 4092,
	"./cac.webp": 7448,
	"./carbon-footprint.jpg": 2838,
	"./carbon-footprint.webp": 8568,
	"./civil-litigation.jpg": 8715,
	"./civil-litigation.webp": 5799,
	"./divorce.jpg": 125,
	"./divorce.webp": 4375,
	"./due-diligence (2).jpg": 4823,
	"./due-diligence (2).webp": 7153,
	"./due-diligence.jpg": 2000,
	"./due-diligence.webp": 9776,
	"./esg-reporting.jpg": 4725,
	"./esg-reporting.webp": 2827,
	"./in-house.jpg": 5233,
	"./in-house.webp": 2797,
	"./internal-audit.jpg": 2086,
	"./internal-audit.webp": 6408,
	"./ipo.jpg": 2725,
	"./ipo.webp": 3079,
	"./it-audit.jpg": 810,
	"./it-audit.webp": 3772,
	"./litigation.jpg": 3969,
	"./litigation.webp": 7469,
	"./other-law.jpg": 8790,
	"./other-law.webp": 4658,
	"./payroll.jpg": 6644,
	"./payroll.webp": 6548,
	"./qar.jpg": 4007,
	"./qar.webp": 3817,
	"./special-audit.jpg": 7395,
	"./special-audit.webp": 9328,
	"./statement-audit.jpg": 1330,
	"./statement-audit.webp": 1906,
	"./statement-review.jpg": 3671,
	"./statement-review.webp": 6799,
	"./system-development.jpg": 1960,
	"./system-development.webp": 9710,
	"./tax-law.jpg": 7419,
	"./tax-law.webp": 3125,
	"./testament.jpg": 2526,
	"./testament.webp": 8022,
	"./transfer-pricing.jpg": 4055,
	"./transfer-pricing.webp": 187,
	"./web-hosting.jpg": 9752,
	"./web-hosting.webp": 1892,
	"./web-maintenance.jpg": 7319,
	"./web-maintenance.webp": 6329,
	"./web-service.jpg": 3667,
	"./web-service.webp": 4437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6315;